export const AddressColumns = [
    "destination",
    "delivery_address",
    "buyer_address",
    "buyer_code",
    "delivery_code",
    "revised_delivery_address"

  
]